// extracted by mini-css-extract-plugin
export default {"link":"NavigationLink_link__o0q0O","linkLight":"NavigationLink_linkLight__33HNI","linkDark":"NavigationLink_linkDark__k6fXL"};